import { useContext } from 'react';

import { CurrentStaticDataContext } from '../providers/current-static-data';

export function useCurrentStaticData() {
  return useContext(CurrentStaticDataContext);
}
